import fireteamIcon from '../../../../../medias/fireteam_icon.png';
import turretsIcon from '../../../../../medias/turrets_icon.png';
import flightIcon from '../../../../../medias/flight_icon.png';

/** Canonical basic requirements shown in roster matrix and dashboard. */
export const BASIC_REQUIREMENT_CODES = ['FIRETEAM_BASIC', 'TURRETS_OPERATOR'];

/** Static icons keyed by academyModuleRequirements.code */
export const TRAINING_ICON_BY_CODE = {
  FIRETEAM_BASIC: fireteamIcon,
  TURRETS_OPERATOR: turretsIcon,
  FIGHTER_PILOT: flightIcon,
};

export { fireteamIcon, turretsIcon, flightIcon };

export function isFighterPilotTraining(training) {
  const code = (training?.code || '').trim().toUpperCase();
  if (code === 'FIGHTER_PILOT') return true;
  const label = (training?.label || '').trim().toLowerCase();
  return label.includes('fighter') && label.includes('pilot');
}

export function getTrainingIconSrc(training) {
  if (!training) return null;
  const code = (training.code || '').trim().toUpperCase();
  if (code && TRAINING_ICON_BY_CODE[code]) {
    return TRAINING_ICON_BY_CODE[code];
  }
  if (isFighterPilotTraining(training)) {
    return flightIcon;
  }
  return null;
}

export function getTrainingIconAlt(training) {
  return (training?.label || '').trim() || 'Training';
}
